<template>
  <b-card>
    <b-card-header>
      <h2>Outreach</h2>
    </b-card-header>
    <b-card-body>
      <p class="textLeft">
        We at Shades of Polaris, LLC are dedicated to giving back to the gaming community and the greater community as a whole.
        As such we wish to spotlight causes of note in our <strong>Featured Causes</strong> below. In addition, you can see any past supported cause 
        in the <strong>Past Causes</strong> section.
      </p>
      <div class="tab-container">
        <tabbed-display v-bind:tabs="tabs" width="100%"></tabbed-display>
      </div>
    </b-card-body>
  </b-card>
</template>
<script>
import FeaturedCause from './FeaturedCause'
import PastCause from './PastCause'
import TabbedDisplay from '@/components/TabbedDisplay/TabbedDisplay'
import { DisplayTab } from '@/components/TabbedDisplay/DisplayTab.js'
export default {
  name: 'CharityView',
  components: { TabbedDisplay },
  data () {
    return {
      msg: 'Charities',
      tabs: []
    }
  },
  mounted () {
    this.tabs.push(new DisplayTab('featured', 'Featured Causes', 1, '', [FeaturedCause]))
    this.tabs.push(new DisplayTab('past', 'Past Causes', 2, '', [PastCause]))
  }
}
</script>
<style scoped>
  .textLeft {
    text-align: left;
  }

</style>
